module.exports = __webpack_public_path__ + "static/img/Circle_Tool.6fcdda2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/Circle_Tool.png
// module id = 1104
// module chunks = 21